import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Typography,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { get } from "lodash";
import React from "react";
import { useTranslate } from "react-admin";

const ApprovalDialog = ({ record, onCloseRequest }) => {
	const translate = useTranslate();
	const supervisorNotes = get(record, "supervisor_notes");
	const rejected = get(record, "status", "none") === "rejected";
	const handleClose = () => onCloseRequest();
	return (
		<Dialog open={record !== null} maxWidth="sm" fullWidth>
			<DialogTitle>
				{translate("resources.bookmaker-approvals.titles.view")}
			</DialogTitle>
			<DialogContent>
				{supervisorNotes && rejected && (
					<DialogContentText component="div">
						<Alert severity="warning">
							{translate(
								"resources.bookmaker-approvals.helpers.supervisor_notes"
							)}
							<strong>{supervisorNotes}</strong>
						</Alert>
					</DialogContentText>
				)}
				<Typography variant="body1">{get(record, "notes")}</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>{translate("ra.action.close")}</Button>
			</DialogActions>
		</Dialog>
	);
};
export default ApprovalDialog;
